import { Box } from '@osmosis/react-ui/components/Box';
import * as motion from 'motion/react-m';
import React, { useState } from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import { MatrixData } from '../../../../types/quiz';
import { P } from '@osmosis/react-ui/components/Text';
import { QuizContainer } from '../../QuizContainer';
import QuizSubmitButtons from '../../QuizSubmitButtons';
import { CorrectBanner, SkipQuizButton } from '../utils';
import MatrixRows from './MatrixRows';

export type optionType = {
  [index: number]: number;
};

/**
 * Https://elsevier.atlassian.net/browse/OSMS-689.
 */
const Matrix = () => {
  const { currentItem, isAnswered, submitAnswer } = useQuizContext();
  const currentData = currentItem?.data as MatrixData;
  const [checkedOptions, setCheckedOptions] = useState<optionType>({});

  const isChosen =
    Object.keys(checkedOptions).length === currentData.answers.rows.length;

  const correctOptions: optionType = currentData.answers.rows.reduce(
    (acc, cur, index) => ({ ...acc, [index]: Number(cur.correctValue) }),
    {},
  );

  const isCorrect =
    JSON.stringify(checkedOptions) === JSON.stringify(correctOptions);

  const handleChoice = (row: number, col: number) => {
    if (!isAnswered)
      setCheckedOptions((prev) => {
        return { ...prev, [row]: col };
      });
  };

  return (
    <QuizContainer>
      <P
        fontSize={16}
        color="gray50"
        fontWeight={400}
        textAlign="justify"
        dangerouslySetInnerHTML={{
          __html: currentData.question,
        }}
      />

      <Box
        as="table"
        sx={{ borderCollapse: 'separate', borderSpacing: '0 1em' }}
      >
        <Box as="thead" textAlign="justify">
          <Box as="tr">
            <Box as="th" width="100%">
              <P textAlign="left" fontSize="14px" fontWeight={900}>
                {currentData.answers.optionsHeader}
              </P>
            </Box>
            {currentData.answers.columns.map(({ name }) => (
              <Box as="th" key={name}>
                <P m="1px" textAlign="center" fontSize="14px" fontWeight={900}>
                  {name}
                </P>
              </Box>
            ))}
          </Box>
        </Box>
        <Box as="tbody">
          <MatrixRows
            checkedOptions={checkedOptions}
            handleChoice={handleChoice}
          />
        </Box>
      </Box>
      {isChosen && !isAnswered && (
        <motion.div
          initial={{ opacity: 0, scaleY: 0 }}
          animate={{ opacity: 1, scaleY: 1 }}
          transition={{ duration: 0.5 }}
        >
          <QuizSubmitButtons
            submit={(c) => submitAnswer(c, isCorrect, checkedOptions)}
          />
        </motion.div>
      )}
      {isAnswered && <CorrectBanner isCorrectAnswer={isCorrect} />}
      <SkipQuizButton />
    </QuizContainer>
  );
};

export default Matrix;
